define('app/views/async_loading_coupons',['app/setup', 'app/views/base_view'], function(takhfifan, baseView) {

  takhfifan.AsyncLoadingCoupons = takhfifan.BaseView.extend({

    initialize: function() {
      this.orderId = this.$el.data('orderId');
      this.items = JSON.parse(this.$el.find('input[name="items-data"]').val());
      this.progressUrl = this.$el.data('progressUrl');
      this.templateId = this.$el.data('templateId');
      this.isNormalCoupon = this.$el.data('isNormalCoupon');
      this.isV2 = this.$el.data('isV2');
      this.checkForUpdate();
      this.template=_.template($(this.templateId).html());
      this.maxTry = 60;
      this.tryCount = 0;
    },

    checkForUpdate: function(){
      this.tryCount++;
      if(this.tryCount > this.maxTry){
        this.showFailedMessage();
        clearTimeout(this.timeOut);
        return;
      }
      var _this = this;
      $.get(this.progressUrl, { order_id: this.orderId } )
        .done(function( data ) {
          data = JSON.parse(data);
          switch(data.status) {
            case 'failed':
              _this.showFailedMessage();
              clearTimeout(_this.timeOut);
              break;
            case 'waiting':
              clearTimeout(_this.timeOut);
              _this.timeOut = setTimeout(function(){_this.checkForUpdate()}, 3000);
              break;
            case 'delayed':
              _this.showDelayMessage();
              clearTimeout(_this.timeOut);
              break;
            case 'completed':
              _this.showCompleteMessage(data.items);
              clearTimeout(_this.timeOut);
              break;
            default:
              clearTimeout(_this.timeOut);
          }
          var msgType=[];
          if (data.items) {
            if (Array.isArray(data.items)) {
              $.each(data.items, function( index, value ) {
                if(!msgType.includes(data.items[index].type)){
                  msgType.push(data.items[index].type)
                }
              });
            } else {
              msgType.push(data.items.type)
            }
          }
          if (msgType.length===1){
            switch (msgType[0]) {
              case 'default':
                $('#default_msg').show();
                break;
              case 'hotel_offline':
                $('#hotel_offline_msg').show();
                break;
              case 'hotel':
                $('#hotel_online_msg').show();
                break;
              case 'airplane':
                $('#airplane_msg').show();
                break;
              case 'train':
                $('#train_online_msg').show();
                break;
              case 'train_offline':
                $('#train_offline_msg').show();
                break;
            }
          }
          else if(msgType.length>=2){
            $('#simple_and_train_offline_msg').show();
          }
        })
        .fail(function() {
          _this.showFailedMessage();
        });
    },

    showCompleteMessage:function(items){
      var codesOutput;
      console.log(items);
      if(this.isNormalCoupon){
        codesOutput = $("<p />");
          codesOutput.append(this.template({
            items: items
          }));
      }else{
        codesOutput = this.template(items);
      }

      if(this.isV2){
        console.log('v2?');
        $('.success-loading__loading').hide();
        $('.coupon-item.skeleton-box').hide();
        $('.success-loading__codes').append(codesOutput);
      }else{
        this.$el.find('.success-loading__loading').hide();
        this.$el.find('.success-loading__message').show();
        this.$el.find('.success-loading__codes').append(codesOutput);
        this.$el.find('.success-loading__codes').show();
      }
      this.sendOfflineHotelDataToWebEngage(items);
    },

    showFailedMessage:function(){
      this.$el.find('.success-loading__loading').hide();
      this.$el.find('.success-loading__error').show();
    },

    showDelayMessage:function(){
      var $errorContainer = this.$el.find('.success-loading__error');
      $errorContainer.find('p').remove();

      var errorMessageTemplate = _.template(this.$el.find('#tkh-success-loading__error-delay').html());
      $errorContainer.find('.order-code').append(errorMessageTemplate({}));
      this.$el.find('.success-loading__loading').hide();
      this.$el.find('.success-loading__error').show();
    },

    sendOfflineHotelDataToWebEngage: function (items) {
      if (this.templateId === '#successHotelOfflineTemplate' && items && items.ticket) {
        webengage.track("hotel_booking", {
          "full_name": items.ticket.firstname + ' ' + items.ticket.lastname,
          "checkin_date": items.ticket.checkin_date_en,
          "hotel_city": items.ticket.hotel_city,
          "mobile_number": items.ticket.mobile,
          "email": items.ticket.email,
          "customer_id": '',//offline hotel users are guest
        });
      }
    }
  })
});
